module.exports = __webpack_public_path__ + "img/services_ql.160e7599.jpg";